import { withNamespaces } from '@/i18n/route-namespaces'
import { CompaniesLayout } from '@/layouts/companies-layout'

export const companiesRoute = {
  path: 'companies',
  element: <CompaniesLayout />,
  children: [
    {
      index: true,
      lazy: withNamespaces(['companies', 'members', 'workspaces'], async () => {
        const { CompaniesListPage } = await import('@/pages/company/list')

        return { Component: CompaniesListPage }
      }),
    },
  ],
}
